import { Injectable, NgZone } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { BehaviorSubject, Observable } from 'rxjs';
import { map, tap } from 'rxjs/operators';


@Injectable()
export class ChatService {
  // private membersSubject = new BehaviorSubject<any[]>([]);
  // members$ = this.membersSubject.asObservable();
  // posts: null;
  // selectedUser: null;

  private membersSubject: BehaviorSubject<any[]> = new BehaviorSubject<any[]>([]);
  public members$: Observable<any[]> = this.membersSubject.asObservable();

  constructor(private http: HttpClient, private zone: NgZone) { }

  // getMembers(params) {
  //   return this.http.post<any>(environment.apiUrl + 'chatMembers', params).subscribe(data => {
  //     if (data.status === 200) {
  //       const members = Object.values(data.result);

  //       // Update the BehaviorSubject with the new data
  //       this.membersSubject.next(members);

  //       if (!data.count) {
  //         this.posts = null;
  //         this.selectedUser = null;
  //       }
  //     }
  //   }, error => {
  //   });
  // }

  //    private getMembersFromApi(params): Observable<any> {
  //     return this.http.post<any>(environment.apiUrl + 'chatMembers', params).pipe(
  //       map(data => {
  //         if (data.status === 200) {
  //           return data;
  //         } else {
  //           return [];
  //         }
  //       }),
  //       tap(data => {
  //         this.zone.run(() => {
  //           const newLastUpdated = data.lastUpdated || 0;

  //           if (newLastUpdated !== this.lastUpdated) {
  //             this.lastUpdated = newLastUpdated;
  //             this.membersSubject.next(Object.values(data.result));
  //           }
  //         });
  //       })
  //     );
  //   }

  //   reloadMembers(type: string) {
  //     const limit = this.pageSize;
  //     const offset = 0;
  //     const params = {
  //       chatgroup: type,
  //       limit,
  //       offset
  //     };

  //     this.getMembersFromApi(params).subscribe(
  //       () => {
  //       },
  //       error => {
  //       }
  //     );
  //   }
  // }

  // getMembers(params): Observable<any> {
  //   return this.http.post<any>(environment.apiUrl + 'chatMembers', params);
  // }

  // updateMembers(members: any[]): void {
  //   this.membersSubject.next(members);
  // }


  getMembers(params) {
    return this.http.post<any>(environment.apiUrl + 'chatMembers', params).map(data => {
      if (data.status === 200) {
        return data;
      } else {
        return [];
      }
    });
  }

  getMembersTrade(params) {
    return this.http.post<any>(environment.apiUrl + 'trade/tradelisting', params).map(data => {
      if (data) {
        return data;
      } else {
        return [];
      }
    });
  }

  getTradeItemDetail(item_id) {
    return this.http.get<any>(`${environment.apiUrl}trade/tradedetail/${item_id}`).map(data => {
      if (data) {
        return data;
      } else {
        return data;
      }
    });
  }

  getMembersFree(params) {
    return this.http.post<any>(environment.apiUrl + 'free/itemlisting', params).map(data => {
      if (data) {
        return data;
      } else {
        return [];
      }
    });
  }


}



// WEBPACK FOOTER //
// ./src/app/_services/chat.service.ts